import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

const desktopQuery = window.matchMedia('(min-width: 768px)');
const instances = [];

function getAutoplayConfig(element) {
  let datasetSource = element && element.dataset ? element : null;

  if (!datasetSource && element && element.closest) {
    datasetSource = element.closest('.image-text--slider');
  }

  const dataset = datasetSource && datasetSource.dataset ? datasetSource.dataset : {};

  return {
    desktopEnabled: dataset.autoplayDesktop === '1',
    mobileEnabled: dataset.autoplayMobile === '1',
    delay: Number.parseInt(dataset.autoplayDelay || '5000', 10) || 5000,
  };
}

function shouldAutoplay(element) {
  const config = getAutoplayConfig(element);

  return desktopQuery.matches ? config.desktopEnabled : config.mobileEnabled;
}

function syncAutoplay(swiper) {
  if (!swiper || !swiper.autoplay) {
    return;
  }

  if (!swiper.el) {
    swiper.autoplay.stop();
    return;
  }

  const shouldRun = shouldAutoplay(swiper.el);
  swiper.params.autoplay.enabled = shouldRun;

  if (shouldRun) {
    swiper.autoplay.start();
    return;
  }

  swiper.autoplay.stop();
}

function initBannerImageTextSliders() {
  const blocks = document.querySelectorAll('.image-text--slider');

  blocks.forEach(block => {
    if (block.dataset.bannerSliderInitialized === 'true') {
      return;
    }

    const swiperEl = block.querySelector('.image-text__swiper');
    const paginationEl = block.querySelector('.swiper-pagination');

    if (!swiperEl || !paginationEl) {
      return;
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    if (slideCount < 2) {
      return;
    }

    const autoplayConfig = getAutoplayConfig(swiperEl);

    block.dataset.bannerSliderInitialized = 'true';

    const swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 600,
      watchOverflow: true,
      pagination: {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      },
      autoplay: {
        delay: autoplayConfig.delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        enabled: false,
      },
      on: {
        init() {
          syncAutoplay(this);
        },
        afterInit() {
          syncAutoplay(this);
        },
      },
    });

    instances.push(swiper);
    syncAutoplay(swiper);
  });
}

document.addEventListener('DOMContentLoaded', initBannerImageTextSliders);

if (document.readyState !== 'loading') {
  initBannerImageTextSliders();
}

desktopQuery.addEventListener('change', () => {
  instances.forEach(syncAutoplay);
});